module.exports = __webpack_public_path__ + "static/media/dsr_journey6.651e7fc4.svg";